export default __webpack_public_path__ + "static/media/edit-icon.aec73c23.svg";